import { BASE_URL } from '../../../Constant';

export const API_ADMIN_FEEDBACKS: string = BASE_URL + '/admin/feedbacks';
